import { operators as o, generators as g } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';

const { VOC } = PRODUCT_AREAS || {};
const { CAPTURE } = SUB_PRODUCT_AREAS || {};

export default {
    name: 'ImportGuides',
    productArea: VOC,
    subProductArea: CAPTURE,
    responseFormat: 'rows',
    build: ({ appId, groupIds, type }) => {
        const guideFilterStatement = () => {
            if (type === 'guide') {
                return '!contains(pollTypes, "NPSRating")';
            }

            return 'contains(pollTypes, "NPSRating")';
        };
        const pipe = o.pipeline(
            o.sources.guides({ appId }),
            o.merge(
                ['id'],
                o.mappings({
                    validPollCount: 'validPollCount',
                    validPolls: 'validPolls',
                    pollTypes: 'pollTypes',
                }),
                o.pipeline(
                    o.sources.guides({ appId }),
                    o.unwind('polls'),
                    ...(type === 'NPS' ? [o.filter('polls.attributes.type == "NPSRating"')] : []),
                    o.group(
                        ['id'],
                        o.groupField('validPollCount', o.count(null)),
                        o.groupField('validPolls', o.list('polls')),
                        o.groupField('pollTypes', o.list('polls.attributes.type')),
                    ),
                ),
            ),
            o.evaluate({
                guideId: 'id',
                createdBy: 'createdByUser.username',
                lastUpdatedBy: 'lastUpdatedByUser.username',
            }),
            o.filter('!contains(pollTypes, "Vote")'),
            o.filter(guideFilterStatement()),
            ...(type === 'guide' ? [o.filter('validPollCount > 0')] : []),
            g.groupColumn({
                primaryKeys: ['guideId'],
                type: 'guide',
                groupIds,
            }),
            o.filterGroups(groupIds),
            o.select({
                id: 'id',
                appId: 'appId',
                name: 'name',
                group: 'group',
                state: 'state',
                description: 'description',
                lastUpdatedBy: 'lastUpdatedBy',
                lastUpdatedAt: 'lastUpdatedAt',
                createdByUser: 'createdByUser',
                createdBy: 'createdBy',
                createdAt: 'createdAt',
                polls: 'polls',
                validPollCount: 'validPollCount',
                validPolls: 'validPolls',
                autoCreateFeedback: 'autoCreateFeedback',
                pollTypes: 'pollTypes',
            }),
        );

        return pipe;
    },
};
